import { Doughnut } from 'react-chartjs-2'
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import React from 'react'

ChartJS.register(ArcElement, Tooltip, Legend)

interface LoanToValueChartProps {
  deposit: number
  borrowing: number
  loanToValue?: number
}

const ltv = (deposit: number, borrowing: number) => Math.floor(100 - (deposit / borrowing) * 100)

export const LoanToValueChart = ({
  deposit,
  borrowing,
  loanToValue = ltv(deposit, borrowing),
}: LoanToValueChartProps) => {
  const data = {
    datasets: [
      {
        label: 'Poll',
        data: [deposit, borrowing],
        backgroundColor: ['#000000', '#AC96DE'],
        borderColor: ['#000000', '#AC96DE'],
        circumference: 180,
        rotation: 270,
      },
    ],
  }

  const options = {
    cutout: 80,
  }

  return (
    <div className='LoanToValueChart__donut-box'>
      <Doughnut data={data} options={options} />
      <div className='LoanToValueChart__loan-details-container'>
        <div className='LoanToValueChart__loan-details-value'>{loanToValue}%</div>
        <div>loan to value</div>
      </div>
    </div>
  )
}
